import {
  requestSession,
  getSessionFromLocalStorage,
  clearSessionInLocalStorage,
  storeSessionInLocalStorage,
  forgotPwd,
  checkResetPwdToken,
  resetPwd,
  endSession, getTimeOut, storeSessionExpireDateInLocalStorage, updatePassword, acceptTerms
} from '../api/session';

import {
  validateLoginForm,
  validateEmail,
  validateChangePasswordForm
} from '../utils/session';
import {callApi, storeSessionIdInLocalStorage} from "../api";
import {fetchProfile} from "../api/users";
import {RESET_PASSWORD_TOKEN_EXPIRE_ERROR, GENERAL_API_ERROR, MUST_ACCEPT_TERMS_ERROR} from "../constants";
import {dispatchError, extractSessionIdFromResponse} from "../utils";
import {clearAllUserAlerts} from "./users";

const initialState = {
  attemptedToRestoreSession: false,
  loggedIn: false,
  currentUser: null,
  currentUserComposite: null,
  sessionData: null,

  isLoading: false,
  loginErrors: {},
  loginApiError: null,
  forgotPasswordSuccess: null,
  forgotPasswordErrors: null,
  forgotPasswordApiErrors: null,
  resetPasswordSuccess: null,
  resetPasswordErrors: null,
  resetPasswordApiErrors: null,
  sessionExpireDate: null,
  getSessionTimeoutError: null,
  userActive: false,
  mustAcceptTermsUser: null,
  acceptTermsApiSuccess: null,
  acceptTermsApiErrors: null,
  apiResponse: null,
  apiResponseError: null
};

export const setLoadingStatus = (isLoading = false) => ({
  type: 'session/setLoadingStatus',
  payload: isLoading
});

export const restoreSessionFromLocalStorage = () => (dispatch, getState) => {
  const sessionData = getSessionFromLocalStorage();
  if (!sessionData) {
    return null;
  }

  const { user, userComposite, session , sessionExpireDate} = sessionData;

  if (user && session) {
    dispatch({
      type: 'session/userLoggedIn',
      payload: {
        userData: JSON.parse(user),
        userComposite: JSON.parse(userComposite),
        sessionData: session,
        sessionExpireDate: sessionExpireDate
      }
    });
  }

  dispatch({ type: 'session/attemptedToRestoreSession' });
};

async function completeLogin(user, dispatch) {
  const queryParams = {
    loggedInUser: user.username,
    sessionId: user.loggedInUserSessionId
  }

  const userComposite = await fetchProfile(queryParams, user);

  dispatch({
             type: 'session/userLoggedIn',
             payload: {
               userData: user,
               userComposite: userComposite,
               sessionData: userComposite.user.loggedInUserSessionId,
             }
           });
  storeSessionInLocalStorage(JSON.stringify(user), JSON.stringify(userComposite), userComposite.user.loggedInUserSessionId);
}

export const loginUser = (username, password) => async (dispatch, getState) => {
  const formErrors = validateLoginForm(username, password)
  if (formErrors) {
    dispatch({
      type: 'session/userLoginFailed',
      payload: formErrors
    });

    return null;
  }

  try {
    const body = {
      pCode: password
    }

    const response = await requestSession(username, body);
    const { user } = await response;

    if (user.apiError === MUST_ACCEPT_TERMS_ERROR) {
      dispatch({
          type: 'session/mustAcceptTerms',
          payload: user
        }
      );
    } else {
      await completeLogin(user, dispatch);
    }
  } catch (error) {
    dispatch({
      type: 'session/userLoginApiFailed',
      payload: error || GENERAL_API_ERROR
    });
  }
  dispatch(setLoadingStatus(false))
};

export const acceptTermsAndConditions = (user) => async (dispatch, getState) => {
  try {
    const response = await acceptTerms(user);

    await completeLogin(response, dispatch);
  } catch (error) {
    dispatch({
      type: 'session/acceptTermsApiFailed',
      payload: error,
    });
  }
}

export const logoutUser = () => async (dispatch, getState) => {
  await dispatch(setLoadingStatus(true))
  const state = getState();
  const mustAcceptTermsUser = state.session.mustAcceptTermsUser;
  await endSession((mustAcceptTermsUser) ? mustAcceptTermsUser.username : state.session.currentUser.username);
  await dispatch (
    clearAllUserAlerts()
  );
  await dispatch (
    clearGetApiResponseError()
  );

  dispatch({
    type: 'session/userLoggedOut',
    payload: null
  });
  clearSessionInLocalStorage()


  dispatch(setLoadingStatus(false))
};

export const sendForgotPassword = (email) =>  async (dispatch, getState) => {
  const formErrors = validateEmail(email);

  if (formErrors) {
    dispatch({
      type: 'session/forgotPasswordFailed',
      payload: {
        email: formErrors
      }
    });
    return null;
  }

  try {
    const response = await forgotPwd(email);

    dispatch ({
      type: 'session/forgotPasswordSucceeded'
    });

  } catch (error) {
    dispatch({
      type: 'session/forgotPasswordApiFailed',
      payload: error
    });
  }
}

export const sendResetPassword = (password, confirmPassword, token) =>  async (dispatch, getState) => {
  const formErrors = validateChangePasswordForm(password, confirmPassword);

  if (formErrors) {
    dispatch({
      type: 'session/resetPasswordFailed',
      payload: {
        password: formErrors.password,
        confirmPassword: formErrors.confirmPassword
      }
    });
    return null;
  }

  try {
    const queryParams = {
      newUserToken: token
    }

    const body = {
      pwd: password
    }

    const response = await updatePassword(queryParams, body);

    if (!response.ok) {
      dispatch ({
        type: 'session/resetPasswordApiFailed',
        payload: RESET_PASSWORD_TOKEN_EXPIRE_ERROR
      })
    } else {
      dispatch ({
        type: 'session/resetPasswordSucceeded'
      });
    }
  } catch (error) {
    dispatch({
      type: 'session/resetPasswordApiFailed',
      payload: error
    });
  }
}

export const getSessionTimeout = (sessionId) => async (dispatch, getState) => {
  const state = getState();
    const queryParams = {
        loggedInUserName: state.session.currentUser.username,
        sessionId: state.session.sessionData
    }

    try {
      const response = await getTimeOut(queryParams);

      storeSessionIdInLocalStorage(response.loggedInUserSessionId);
      storeSessionExpireDateInLocalStorage(response.sessionExpireDate);

      dispatch({
          'type': 'session/gotSessionTimeout',
          'payload': {
            sessionExpireDate: response.sessionExpireDate,
            sessionId: response.loggedInUserSessionId
          }
      });
    } catch (error) {
        await dispatchError( error, {
            type: 'session/getSessionTimeoutFailed',
            payload: error
        }, dispatch);
    }
}

export const setUserActive = (userActive) => {
  return {
    type: 'session/setUserActive',
    payload: userActive
  }
}

export const clearLoginErrors = () => {
  return {
    type: 'session/clearLoginErrors'
  }
}

export const clearAllForgotPasswordAlerts = () => {
  return {
    type: 'session/clearAllForgotPasswordAlerts'
  }
}

export const clearForgotPasswordSuccess = () => {
  return {
    type: 'session/clearForgotPasswordSuccess'
  }
}

export const clearResetPasswordSuccess = () => {
  return {
    type: 'session/clearResetPasswordSuccess'
  }
}

export const clearResetPasswordApiErrors = () => {
  return {
    type: 'session/clearResetPasswordApiErrors'
  }
}

export const clearAcceptTerms = () => {
  return {
    type: 'session/clearAcceptTerms'
  }
}

export const updateSessionId = (sessionId) => {
  storeSessionIdInLocalStorage(sessionId);

  return {
    type: 'session/updateSessionId',
    payload: sessionId
  }
}

export const getApiResponse = (url, params) => async (dispatch, getState) => {
  try {
    const response = await callApi(url, params);

    const newSessionId = await extractSessionIdFromResponse(response);
    await dispatch(updateSessionId(newSessionId));

    await dispatch({
      type: 'session/getApiResponse',
      payload: response
    });
  } catch (error) {
    await dispatchError( error, {
      type: 'session/getApiResponseError',
      payload: error
    }, dispatch);
  }
}

export const clearGetApiResponseError = () => {
  return {
    type: 'session/clearGetApiResponseError'
  }
}

export default function sessionReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'session/userLoggedIn':
      return {
        ...state,
        loggedIn: true,
        loginErrors: {},
        sessionData: payload.sessionData,
        currentUser: payload.userData,
        currentUserComposite: payload.userComposite,
        sessionExpireDate: payload.sessionExpireDate,
        mustAcceptTermsUser: null
      };
    case 'session/userLoginFailed':
      return {
        ...state,
        loginErrors: payload,
        mustAcceptTermsUser: null
      }
    case 'session/userLoginApiFailed':
      return {
        ...state,
        loginApiError: payload,
        loginErrors: {},
        mustAcceptTermsUser: null
      }
    case 'session/forgotPasswordFailed':
      return {
        ...state,
        forgotPasswordErrors: payload
      }
    case 'session/forgotPasswordApiFailed':
      return {
        ...state,
        forgotPasswordApiErrors: payload
      }
    case 'session/forgotPasswordSucceeded':
      return {
        ...state,
        forgotPasswordSuccess: true,
        forgotPasswordErrors: null,
        forgotPasswordApiErrors: null
      }
    case 'session/userLoggedOut':
      return {
        ...state,
        loggedIn: false,
        loginErrors: {},
        currentUser: null,
        sessionData: null,
        mustAcceptTermsUser: null
      };

    case 'session/setLoadingStatus':
      return {
        ...state,
        isLoading: payload
      };

    case 'session/attemptedToRestoreSession':
      return {
        ...state,
        attemptedToRestoreSession: true
      };
    case 'session/resetPasswordFailed':
      return {
        ...state,
        resetPasswordErrors: payload
      }
    case 'session/resetPasswordApiFailed':
      return {
        ...state,
        resetPasswordSuccess: null,
        resetPasswordErrors: null,
        forgotPasswordApiErrors: null,
        forgotPasswordErrors: null,
        forgotPasswordSuccess: null,
        resetPasswordApiErrors: payload
      }
    case 'session/resetPasswordSucceeded':
      return {
        ...state,
        resetPasswordSuccess: true,
        resetPasswordErrors: null,
        resetPasswordApiErrors: null,
        forgotPasswordApiErrors: null,
        forgotPasswordErrors: null,
        forgotPasswordSuccess: null
      }
    case 'session/updateSessionId':
      return {
        ...state,
        sessionData: payload
      }
    case 'session/gotSessionTimeout':
      return {
        ...state,
        sessionExpireDate: payload.sessionExpireDate,
        sessionData: payload.sessionId
      }
    case 'session/getSessionTimeoutFailed':
      return {
        ...state,
        sessionTimeoutError: payload
      }
    case 'session/setUserActive':
      return {
        ...state,
        userActive: payload
      }
    case 'session/clearForgotPasswordErrors':
      return {
        ...state,
        forgotPasswordApiErrors: null,
        forgotPasswordSuccess: null,
        forgotPasswordErrors: {}
      }
    case 'session/clearLoginErrors':
      return {
        ...state,
        loginErrors: {},
        loginApiError: null,
        forgotPasswordApiErrors: null,
        forgotPasswordSuccess: null,
        forgotPasswordErrors: {},
        resetPasswordSuccess: null,
        resetPasswordApiErrors: null,
        resetPasswordErrors: null,
        //clear these out as well just to be safe
        resetPasswordTokenSuccess: null,
        resetPasswordTokenErrors: null

      }
    case 'session/clearForgotPasswordSuccess':
      return {
        ...state,
        forgotPasswordSuccess: null,
        forgotPasswordApiErrors: null,
        forgotPasswordErrors: null
      }
    case 'session/clearResetPasswordSuccess':
    case 'session/clearResetPasswordApiErrors':
      return {
        ...state,
        resetPasswordSuccess: null,
        resetPasswordApiErrors: null,
        resetPasswordErrors: null,
        //clear these out as well just to be safe
        resetPasswordTokenSuccess: null,
        resetPasswordTokenErrors: null
      }
    case 'session/clearAllForgotPasswordAlerts':
      return {
        ...state,
        loginErrors: {},
        loginApiError: null,
        forgotPasswordSuccess: null,
        forgotPasswordErrors: null,
        forgotPasswordApiErrors: null,
        resetPasswordSuccess: null,
        resetPasswordApiErrors: null,
        resetPasswordErrors: null,
      }
    case 'session/mustAcceptTerms':
      return {
        ...state,
        mustAcceptTermsUser: payload
      }
    case 'session/acceptTermsApiSucceeded':
      return {
        ...state,
        acceptTermsApiErrors: null,
        mustAcceptTermsUser: null,
        acceptTermsApiSuccess: true
      }
    case 'session/acceptTermsApiFailed':
      return {
        ...state,
        acceptTermsApiSuccess: null,
        acceptTermsApiErrors: payload
      }
    case 'session/clearAcceptTerms':
      return {
        ...state,
        acceptTermsApiSuccess: null,
        acceptTermsApiErrors: null,
        mustAcceptTermsUser: null
      }
    case 'session/getApiResponse':
      return {
        ...state,
        apiResponse: payload,
        apiResponseError: null
      }
    case 'session/getApiResponseError':
      return {
        ...state,
        apiResponse: null,
        apiResponseError: payload
      }
    case 'session/clearGetApiResponseError':
      return {
        ...state,
        apiResponse: null,
        apiResponseError: null
      }
    default:
      return state;
  }
}
